import { ModalsKey } from '@/enums/modalsKey';
import { useModalNavigation } from '@/hooks/modals/useModalNavigation';
import { RootState } from '@/lib/store';
import { AuthService } from '@/services/AuthService';
import { LottieOrImage } from '@starsoft/common/components';
import { useLottiePlayer } from '@starsoft/common/hooks';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import SidebarItemSection from '../Item/Section';
import styles from './styles.module.scss';

export default function SidebarContentBonus() {
  const { t } = useTranslation('common');
  const isAdminView = useSelector(
    (state: RootState) => state.theme.isAdminEmbed,
  );
  const lottiePlayer = useLottiePlayer({
    path: '/gift-box.json',
  });
  const { navigateToModal } = useModalNavigation();
  const { push } = useRouter();

  function handleNavigate() {
    if (isAdminView) {
      return;
    }

    if (!AuthService.isAuthorized()) {
      navigateToModal(ModalsKey.Login);
      return;
    }

    push(`/bonus`);
  }

  return (
    <SidebarItemSection label={t('rewards_title')} onClick={handleNavigate}>
      <LottieOrImage
        lottie={lottiePlayer}
        icon="fa-solid fa-gift"
        classList={{ lottie: styles.lottie, image: styles.icon }}
        image={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/general/gift.png`}
      />
    </SidebarItemSection>
  );
}
